import { ClassicPreset } from 'rete';
import { ApolloProvider } from '@apollo/client';
import { FC } from 'react';
import { NodeData } from '../dataNode';
import apolloClient from '../../../createApollo';
import { Comments } from './Comments';

export class CommentsControlData extends ClassicPreset.Control {
  constructor(
    public data: NodeData,
    public component: FC<{ data: NodeData; readOnly: boolean; onChange: (data: NodeData) => void }>,
    public onChange: (data: NodeData) => void,
    public readOnly = false,
  ) {
    super();
    this.component = () => (
      <ApolloProvider client={apolloClient}>
        <Comments data={data} onChange={onChange} readOnly={readOnly} />
      </ApolloProvider>
    );
  }
}
